import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import Modal from '../../molecules/Modal/Modal';

import SimpleCheckout from './SimpleCheckout';
import { setShowModalCheckout } from '../../../redux/slices/plans.slice';
import PaymentInstructions from './PaymentInstructions';
import { clearPaymentInstructions } from '../../../redux/slices/cart.slice';
import ROUTES from '../../../shared/constants/routes';
import { useNavigate, useSearchParams } from 'react-router-dom';
import LOCAL_STORAGE_KEY from '../../../shared/constants/localStorageKey';
import Button from '../../../components/atoms/Button/index';
import Text from '../../../components/atoms/Text/index';
import { useState } from 'react';
import TAGGING from '../../../shared/constants/tagging';

const ModalCheckout = () => {
	const { showModalCheckout } = useSelector((state: RootState) => state.plans);
	const { paymentInstructions } = useSelector((state: RootState) => state.cart);
	const tags = useSelector((state: RootState) => state.profile.tags);
	const tagging = tags.find(tagging => tagging.tag === TAGGING.HIGH_VALUE_CART);

	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const [showWhatsAppBanner, setShowWhatsAppBanner] = useState(false);
	const [showConfirmModal, setShowConfirmModal] = useState(false);
	const [regime, setRegime] = useState('');

	const closeAllModals = () => {
		dispatch(setShowModalCheckout(false));
		setShowConfirmModal(false);
		setShowWhatsAppBanner(false);
		sessionStorage.removeItem(LOCAL_STORAGE_KEY.ANNUAL);
		sessionStorage.removeItem(LOCAL_STORAGE_KEY.CHECKOUT);
		const newSearchParams = new URLSearchParams(searchParams);
		newSearchParams.delete('annual');
		newSearchParams.delete('checkout');
		newSearchParams.delete('product_added');
		setSearchParams(newSearchParams);
		if (paymentInstructions.show) {
			dispatch(clearPaymentInstructions());
			navigate(ROUTES.ROOT);
		}
	};

	const onClose = () => {
		if (
			showWhatsAppBanner &&
			!paymentInstructions.show &&
			tagging
		) {
			setShowConfirmModal(true);
			return;
		}
		closeAllModals();
	};

	const handleWhatsAppClick = () => {
		if (regime === 'resico') {
			window.open('https://heru.trb.ai/wa/lQi7gK', '_blank');
		} else if (regime === 'actividad empresarial') {
			window.open('https://heru.trb.ai/wa/lQi7gL', '_blank');
		} else {
			window.open('https://heru.trb.ai/wa/lQi7gM', '_blank');
		}
	};

	const onTotalChange = (showBanner: boolean, regime: string) => {
		setShowWhatsAppBanner(showBanner);
		setRegime(regime);
	};

	return (
		<>
			<Modal
				open={showModalCheckout}
				onClose={onClose}
				sx='!p-0 md:!p-8 w-[94%] h-[90%] md:h-fit overflow-y-auto md:w-4/5 relative max-h-[90%]'
			>
				{paymentInstructions.show ? (
					<PaymentInstructions
						paymentMethod={paymentInstructions.paymentMethod}
						total={paymentInstructions.total}
						reference={paymentInstructions.reference}
					/>
				) : (
					<SimpleCheckout onTotalChange={onTotalChange} />
				)}
			</Modal>

			<Modal
				open={showConfirmModal}
				onClose={() => setShowConfirmModal(false)}
				sx='p-6 w-[90%] md:w-[500px]'
			>
				<div className='flex flex-col gap-2'>
					<Text
						size='body-1'
						weight='bold'
						sx='text-center mb-2 justify-center'
					>
						¿Tienes dudas de la contratación?
					</Text>
					<Text
						size='body-3'
						weight='regular'
						sx='text-center mb-4'
					>
						Te ofrecemos una asesoría fiscal sin costo para resolverlas con uno
						de nuestros expertos.
					</Text>
					<Button
						variant='primary'
						label='Recibir asesoría fiscal gratis'
						onClick={handleWhatsAppClick}
					/>
					<Button
						variant='text'
						label='Abandonar compra'
						onClick={closeAllModals}
						sx='justify-center mt-2'
						labelColor='blue'
						labelSize='caption'
					/>
				</div>
			</Modal>
		</>
	);
};

export default ModalCheckout;
